import { render, staticRenderFns } from "./ordersReturned.vue?vue&type=template&id=30008bef"
import script from "./ordersReturned.vue?vue&type=script&lang=js"
export * from "./ordersReturned.vue?vue&type=script&lang=js"
import style0 from "./ordersReturned.vue?vue&type=style&index=0&id=30008bef&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports